import React, { useState, useRef, useEffect } from 'react';
import { X, FileText, ChevronLeft, ChevronRight, ArrowLeft, Sun, Moon, Contrast } from 'lucide-react';
import Button from '../../../button/button';
import styles from './ChatHeader.scss';

const CloseIcon = () => <X size={16} />;
const BackIcon = () => <ArrowLeft size={16} />;
const TemplateIcon = () => <FileText size={16} />;
const HideSidebarIcon = () => <ChevronLeft size={16} />;
const ShowSidebarIcon = () => <ChevronRight size={16} />;
const LightModeIcon = () => <Sun size={16} />;
const DarkModeIcon = () => <Moon size={16} />;
const SystemModeIcon = () => <Contrast size={16} />;

const ChatHeader = ({
  showConversationsSidebar,
  onToggleSidebar,
  onToggleTemplates,
  onClose,
  isLightMode,
  themeMode = 'dark',
  onToggleTheme,
  isTemplateView
}) => {
  const [isThemeMenuOpen, setIsThemeMenuOpen] = useState(false);
  const themeMenuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (themeMenuRef.current && !themeMenuRef.current.contains(event.target)) {
        setIsThemeMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Get current theme icon
  const getThemeIcon = () => {
    if (themeMode === 'light') return <LightModeIcon />;
    if (themeMode === 'system') return <SystemModeIcon />;
    return <DarkModeIcon />;
  };

  const handleThemeSelect = (mode) => {
    onToggleTheme(mode);
    setIsThemeMenuOpen(false);
  };
  return (
    <div className={`${styles.header} ${isLightMode ? styles.lightMode : ''}`}>
      <Button
        onClick={onToggleSidebar}
        className={styles.sidebarToggle}
        title={showConversationsSidebar ? "Hide Conversations" : "Show Conversations"}
        icon={showConversationsSidebar ? <HideSidebarIcon /> : <ShowSidebarIcon />}
      />
      <div className={styles.title}>
        <h3>AI Assistant</h3>

      </div>
      <div className={styles.headerActions}>

        <Button
          onClick={onToggleTemplates}
          className={styles.headerButton}
          title="Question Templates"
          icon={<TemplateIcon />}
        />
        
        {onToggleTheme && (
          <div className={styles.themeMenuContainer} ref={themeMenuRef}>
            <Button
              onClick={() => setIsThemeMenuOpen(!isThemeMenuOpen)}
              className={styles.headerButton}
              title="Theme"
              icon={getThemeIcon()}
            />
            {isThemeMenuOpen && (
              <div className={styles.themeDropdown}>
                <div
                  className={`${styles.themeOption} ${themeMode === 'light' ? styles.selected : ''}`}
                  onClick={() => handleThemeSelect('light')}
                >
                  <Sun size={14} />
                  <span>Light</span>
                </div>
                <div
                  className={`${styles.themeOption} ${themeMode === 'system' ? styles.selected : ''}`}
                  onClick={() => handleThemeSelect('system')}
                >
                  <Contrast size={14} />
                  <span>System</span>
                </div>
                <div
                  className={`${styles.themeOption} ${themeMode === 'dark' ? styles.selected : ''}`}
                  onClick={() => handleThemeSelect('dark')}
                >
                  <Moon size={14} />
                  <span>Dark</span>
                </div>
              </div>
            )}
          </div>
        )}
        
        {isTemplateView ? (
          <Button
            onClick={onToggleTemplates}
            className={styles.headerButton}
            title="Back to Chat"
            icon={<BackIcon />}
          />
        ) : (
          <Button
            onClick={onClose}
            className={styles.headerButton}
            title="Close Chat"
            icon={<CloseIcon />}
          />
        )}
      </div>
    </div>
  );
};

export default ChatHeader;

